import { render, staticRenderFns } from "./TestRunInfoPanel.vue?vue&type=template&id=18d80f99"
import script from "./TestRunInfoPanel.vue?vue&type=script&lang=js"
export * from "./TestRunInfoPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports